import { RunStateTransition } from "types/generated";

import RunCanceledEntry from "../entries/CanceledEntry";
import { getRunStateTransitionId } from "./getRunStateTransitionId";

export const createCanceledEntry = ({
  timestamp,
  note,
  username,
  stateVersion,
}: RunStateTransition) => (
  <RunCanceledEntry
    key={getRunStateTransitionId(timestamp, stateVersion)}
    timestamp={timestamp}
    note={note}
    username={username}
  />
);
